<template>
  <div>
     <Loading v-if="isLoading"></Loading>
       <div v-else>
    <CRow>
      <CCol lg="12">
        <GlobalTable
          :title="'Product Assets'"
          :fields="fields"
          :items="items"
          :redirectDetail="false"
          :enableAddButton="false"
          :isLoading="isLoading"
          :withCard="false"
           @previewImage="previewImage"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="previewImages"
    >
      <CImg :src="'https://storage.googleapis.com/isikulkas/'+selectedImages+'?r='+unixTime" :thumbnail="true" />
    
    </CModal>
</div>
  </div>

</template>

<script>

import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

export default {
  name: "Document",
  components: { Loading, GlobalTable },
  data() {
    return {
      title: "Document",
      items:[],
      activeTab: 0,
      preview: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      previewImages: false,
      selectedImages: null,
      fields: [
        { key: "document", label: "URL", sorter: true },
        { key: "document_type", label: "Tipe Document", sorter: true },
      ],
    };
  },
   props: {
    dc_items: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
 
  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
      
            
    },
   
    getProductAsset: function () {
      this.isLoading = true;
      this.axios
          .get("console/partnership/document/"+this.dc_items.partnership_code)
          .then((response) => {
            this.items = response.data.data;
            this.showInfoNotification({
              title: "Get Partner Document",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Get Partner Document");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
    },
        previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    previewImage: function(img){
      console.log(img);
      this.selectedImages = img.document;
      this.previewImages = true;
    }
  },
  mounted() {
    this.getProductAsset();
  },
};
</script>
